import React from 'react';
import { motion } from 'framer-motion';
import { GuaranteeShieldIcon } from './CustomIcons';
export function GuaranteeSection() {
  return <section className="py-16 md:py-20 px-4 bg-carbon" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0A0A0A] rounded-2xl p-6 md:p-12 text-center relative overflow-hidden shadow-[0_0_30px_rgba(242,183,5,0.05)] border border-[#151515]" data-id="element-98">
          {/* Subtle glow effect behind the shield */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-emerald/10 blur-3xl rounded-full" data-id="element-99"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-100">
            <div className="inline-block bg-gold/10 text-gold text-xs font-bold tracking-widest px-3 py-1 rounded-full mb-6" data-id="element-101">
              GARANTÍA
            </div>

            <GuaranteeShieldIcon className="w-12 h-12 md:w-16 md:h-16 text-emerald mb-6" data-id="element-102" />

            <h2 className="text-xl md:text-3xl font-heading font-bold text-gold mb-6 md:mb-8 leading-tight" data-id="element-103">
              "Si no te llenamos la agenda de estimados, no nos pagas."
            </h2>

            <div className="space-y-4 text-base md:text-lg text-white leading-relaxed max-w-xl" data-id="element-104">
              <p data-id="element-105">
                Estamos tan seguros de nuestra ingeniería que si en los primeros
                30 días no tienes un flujo constante de leads calificados...{' '}
                <strong className="text-gold font-bold" data-id="element-106">
                  te devolvemos el 100% de nuestra tarifa de gestión.
                </strong>
              </p>
              <p data-id="element-107">
                Tú pones la mano de obra, nosotros ponemos los clientes. Ese es
                el trato. Sin zonas grises.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}